module.exports = __webpack_public_path__ + "img/bin.4d46423c.svg";